/**
 * 获取图片扩展名
 * @param { string } extName
 */
export function getImageExtendName(imgFile) {
  const result = imgFile.name.match(/.+\.(\w+)$/);
  return result && result[1];
}

/**
 * 读取图片宽高
 * @param { string } imgsrc
 */
export function getImageInfo(imgsrc) {
  return new Promise((resolve, reject) => {
    const oImage = new Image();
    oImage.onload = () => {
      resolve({ width: oImage.width, height: oImage.height, source: oImage });
    };
    oImage.onerror = error => {
      reject(error);
    };
    oImage.src = imgsrc;
  });
}

/**
 * 将base64转换为文件
 * @param {baseURL} dataurl
 * @param {文件名称} filename
 * @return {文件二进制流}
 */
export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

/**
 * 生成新base64格式图片
 * @param { 渲染原图 } img
 * @param { object } options
 * @return { string }
 */
export function renderImage(img, options) {
  const defaults = {
    with: 200,
    height: 200,
    imageType: 'image/jpeg',
    quality: 0.8
  };
  const configs = Object.assign({}, defaults, options);
  const oCanvas = document.createElement('canvas');
  const oCtx = oCanvas.getContext('2d');

  oCanvas.width = configs.width;
  oCanvas.height = configs.height;
  oCtx.drawImage(img, 0, 0, configs.width, configs.height);
  const imageDataStr = oCanvas.toDataURL(configs.imageType, configs.quality);
  return imageDataStr;
}

/**
 * 图片压缩方法
 * @param { string } imgSrc      [description]
 * @param { object } options
 * @return { promise }
 */
export async function compressPic(imgSrc, options) {
  const defaults = {
    dis_w: '',
    dis_h: '',
    default_w: '750',
    default_h: '750',
    type: 'image/jpeg',
    quality: 0.8,
    useW: false // false时按默认高压缩,true时按默认宽压缩
  };
  const configs = Object.assign({}, defaults, options);

  const imgInfo = await getImageInfo(imgSrc);

  // 原图宽高
  const s_w = imgInfo.width;
  const s_h = imgInfo.height;

  // 压缩宽高
  let y_w, y_h;

  if (configs.dis_w && configs.dis_h) {
    if (configs.dis_w <= s_w && configs.dis_h <= s_h) {
      y_w = configs.dis_w;
      y_h = configs.dis_h;
    } else if (configs.dis_w >= s_w && configs.dis_h <= s_h) {
      y_h = configs.dis_h;
      y_w = (configs.dis_h / s_h) * s_w;
    } else if (configs.dis_w <= s_w && configs.dis_h >= s_h) {
      y_w = configs.dis_w;
      y_h = (configs.dis_w / s_w) * s_h;
    }
  } else if (configs.dis_w && !configs.dis_h) {
    if (configs.dis_w <= s_w) {
      y_w = configs.dis_w;
      y_h = (configs.dis_w / s_w) * s_h;
    }
  } else if (configs.dis_h && !configs.dis_w) {
    if (configs.dis_h <= s_h) {
      y_h = configs.dis_h;
      y_w = (configs.dis_h / s_h) * s_w;
    }
  } else if (!configs.dis_w && !configs.dis_h) {
    // 不设压缩宽高时，使用原图的宽高
    y_w = s_w;
    y_h = s_h;
  }

  const imageData = renderImage(imgInfo.source, {
    width: y_w,
    height: y_h,
    quality: configs.quality
  });
  // console.log(imageData);
  return imageData;
}
